module.exports = __webpack_public_path__ + "media/images/flags/nf-d0dc5e078fcde077ab0e6d813abcb584.svg";